export function calculatePercentage(total: number, amount: number): string {
  let percentage: number = (amount * 100) / total
  return `${(percentage === 100) ? '100' : (percentage === 0) ? '0' : percentage.toFixed(2)}%`;
}

export function calculatePriceUnit(price_unit: string, tax_included: boolean, tax_rate: number): number {
  return (tax_included) ? (Number(price_unit) / (1 + tax_rate)) : Number(price_unit)
}

export function calculateRebate(reference: string, quantity: string, price_unit: string, tax_included: boolean, tax_rate: number, rebate_type: string, rebate_value: number, rebate_quantity: number, rebate_amount: string): string {
  if (reference && reference.length > 0) {
    if (Number.isFinite(Number(quantity)) && Number.isFinite(Number(price_unit)) && Number(quantity) > 0 && Number(price_unit) > 0) {
      if ((rebate_type === 'percentage' || rebate_type === 'fixed') && rebate_quantity <= Number(quantity)) {
        return ((rebate_type === 'percentage') ? (((rebate_value / 100) * calculatePriceUnit(price_unit, tax_included, tax_rate)) * Number(quantity)) : (rebate_value * Number(quantity))).toFixed(2)
      } else {
        return '0'
      }
    } else {
      return '0'
    }
  } else {
    return rebate_amount
  }
}

export function isVatSubject(settingsForCompany: any, companyForUser: any): boolean {
  return (settingsForCompany?.subject_tax ?? companyForUser?.subject_tax) === true
}

export function accumulatedAmount(documents: any[]): {subtotal: number, rebate: number, tax: number, total: number, paid: number, debt: number} {
  let amountSubtotal: number = 0
  let amountRebate: number = 0
  let amountTax: number = 0
  let amountTotal: number = 0
  let amountPaid: number = 0
  let amountDebt: number = 0

  for (let document of documents) {
    amountSubtotal += document.amount.sub_total
    amountRebate += document.amount.rebate_total
    amountTax += document.amount.tax_total
    amountTotal += document.amount.total

    if (document.amount.paid) { amountPaid += document.amount.paid }
    if (document.amount.debt) { amountDebt += document.amount.debt }
  }

  return {subtotal: amountSubtotal, rebate: amountRebate, tax: amountTax, total: amountTotal, paid: amountPaid, debt: amountDebt}
}
